import drive from "../assets/drivewise.jpg";
import blood from "../assets/blood.jpg";
import mm from "../assets/mm.png";
import vapor from "../assets/vapor.jpeg";
import optimine from "../assets/optimine.png"
import ripple from "../assets/ripple.jpg";
import kinai from "../assets/kinai.jpg"
import chatbot from "../assets/chatbot.jpeg"


const ProjectCardData = [
  {
    imgsrc: kinai,
    title: "Kinai",
    text: "Winning best solo project at HackAI 2025, Kinai uses computer vision and AI to make physical therapy/training technique analysis extremely quick, actionable, and helpful.",
    tech: "Used Python, OpenAI's API, LLMs, OpenCV, Mediapipe, React, Javascript, and HTML/CSS.",
    view: "https://devpost.com/software/pt-ai-sgkc1v"
  },
  {
    imgsrc: ripple,
    title: "Ripple Banking",
    text: "Winning 3rd Overall at HackUTD 2024, the largest 24 hour hackathon in North America, Ripple Bankng connects underbanked customers to large banks via local small businesses.",
    tech: "Used Python, PyTorch, HTML/CSS, JavaScript",
    view: "https://devpost.com/software/tbd-z4uir2"
  },
  {
    imgsrc: vapor,
    title: "VaporVision",
    text: "Winner of EOG Resources' HackUTD 2023 Challenge, VaporVision is a comprehensive web application that leverages data visualization and AI/ML techniques in order to help detect these leaks in a given area.",
    tech: "Used Python, PyTorch, Scikit-Learn, Streamlit, HTML/CSS, and several python libraries",
    view: "https://devpost.com/software/vaporvision",
  },
  {
    imgsrc: optimine,
    title: "Optimine",
    text: "Winner of EOG Resources' HackUTD 2022 Challenge, Optimine uses data analysis/ML to determine the proper drilling bit based off several factors.",
    tech: "Used Python, Streamlit, HTML/CSS, PyTorch, and Scikit-Learn.",
    view: "https://optimine.streamlit.app"
  },
  {
      imgsrc: chatbot,
      title: "UTD ECS Chatbot",
      text: "Developed a chatbot to assist UT Dallas students in the engineering & CS department regarding registration FAQ due to lack of advisors and lengthy wait times.",
      tech: "Used Python, OpenAI API, LLAMA, GPT, and Streamlit.",
      view: "https://ktputd-ecschatbot.streamlit.app"
  },
  {
    imgsrc: drive,
    title: "DriveWise",
    text: "Inspired by the goal of 0 Crashes, 0 Emissions, and 0 congestion, we developed an app that helps you keep track of your car's maintenance, displays current driving conditions, and dynamically plans your road trips (TamuHack 2023).",
    tech: "Used Swift, Xcode, Visual Crossing API, and MapKit.",
    view: "https://pitchpredictor.streamlit.app",
  },
  {
    imgsrc: blood,
    title: "BloodMetrixx (Blood Test Scanner)",
    text: "Developed a website that parses a blood test document and advises a patient on how to improve their health depending upon certain blood levels (Axxess Hackathon).",
    tech: "Used Python, Streamlit, HTML/CSS, LLAMA, Matplotlib, and OpenAI API. ",
    view: "https://devpost.com/software/vitalia",
  },
  {
    imgsrc: mm,
    title: "March Madness Bracket Predictor",
    text: "Devised a data analysis algorithm that predicted the winner of each NCAA march madness game statistically attempting to create a perfect tournamnet bracket.",
    tech: "Used Python.",
    view: "https://www.github.com/yeshasn/mm-predictor-with-stats",
  },
];

export default ProjectCardData;
